import React from "react";
import * as axios from "axios";
import {TextField, MenuItem, Button, Switch, FormControlLabel, IconButton, Menu} from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import RestoreFromTrashIcon from "@material-ui/icons/RestoreFromTrash";
import HistoryIcon from "@material-ui/icons/History";
import CardGiftcardIcon from "@material-ui/icons/CardGiftcard";
import DelivererModal from "./DelivererModal";
import InventoryModal from "./InventoryModal";
import {formatDate} from "./shiftUtils";
import "./styles.css";

const SHIFT_LABELS = {0: 'Fără tură', 1: 'Tura 1', 2: 'Tura 2', 3: 'MieJoiVin'};

const baseUrl = 'https://api.appetito.ro/';

// 15-minute increments across a full day, e.g. "00:00", "00:15", ... "23:45".
const TIME_OPTIONS = Array.from({length: 24 * 4}, (_, i) => {
  const hours = Math.floor(i / 4);
  const minutes = (i % 4) * 15;
  return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
});

export default class Personal extends React.Component {
  state = {
    users: [],
    cars: [],
    cities: [],
    savingShiftId: null,
    savingHoursId: null,
    savingCarId: null,
    savingBonusId: null,
    modalOpen: false,
    editingDeliverer: null,
    showDeleted: false,
    searchTerm: "",
    historyAnchor: null,
    historyDeliverer: null,
    historyEntries: [],
    carHistoryAnchor: null,
    carHistoryDeliverer: null,
    carHistoryEntries: [],
    inventoryDeliverer: null,
  };

  componentDidMount() {
    this.getDeliverers();
    this.getCars();
    this.getCities();
  }

  getDeliverers = async () => {
    const token = localStorage.getItem('access_token');
    const response = await axios.default.get(`${baseUrl}v1/admin/all-deliverers`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    this.setState({users: response.data})
  }

  getCars = async () => {
    const token = localStorage.getItem('access_token');
    const response = await axios.default.get(`${baseUrl}v1/admin/cars`, {
      headers: {Authorization: `Bearer ${token}`},
    });
    this.setState({cars: response.data || []});
  };

  // Main cities only, same list DelivererModal's "Oraș" field uses — just
  // for showing the name next to each deliverer's city_id here.
  getCities = async () => {
    const response = await axios.default.get(`${baseUrl}v1/city`);
    this.setState({cities: response.data || []});
  };

  cityName = (cityId) => {
    const city = this.state.cities.find((c) => c.id === cityId);
    return city ? city.name : '—';
  };

  updateCar = async (deliverer, carId) => {
    this.setState({savingCarId: deliverer.id});
    try {
      const token = localStorage.getItem('access_token');
      await axios.default.put(`${baseUrl}v1/admin/deliverer/${deliverer.id}/car`, {car_id: carId}, {
        headers: {Authorization: `Bearer ${token}`},
      });
      this.setState({
        users: this.state.users.map((u) => u.id === deliverer.id ? {...u, car_id: carId} : u),
      });
    } catch (e) {
      alert("Eroare la salvarea mașinii.");
    } finally {
      this.setState({savingCarId: null});
    }
  };

  updateShift = async (deliverer, shift) => {
    this.setState({savingShiftId: deliverer.id});
    try {
      const token = localStorage.getItem('access_token');
      await axios.default.put(`${baseUrl}v1/admin/deliverer/${deliverer.id}/shift`, {shift}, {
        headers: {Authorization: `Bearer ${token}`},
      });
      this.setState({
        users: this.state.users.map((u) => u.id === deliverer.id ? {...u, shift} : u),
      });
    } catch (e) {
      alert("Eroare la salvarea turei.");
    } finally {
      this.setState({savingShiftId: null});
    }
  };

  updateBonusEligible = async (deliverer, bonusEligible) => {
    this.setState({savingBonusId: deliverer.id});
    try {
      const token = localStorage.getItem('access_token');
      await axios.default.put(`${baseUrl}v1/admin/deliverer/${deliverer.id}/bonus-eligible`, {bonus_eligible: bonusEligible}, {
        headers: {Authorization: `Bearer ${token}`},
      });
      this.setState({
        users: this.state.users.map((u) => u.id === deliverer.id ? {...u, bonus_eligible: bonusEligible} : u),
      });
    } catch (e) {
      alert("Eroare la salvarea bonusului.");
    } finally {
      this.setState({savingBonusId: null});
    }
  };

  updateWorkingHours = async (deliverer, field, value) => {
    this.setState({savingHoursId: deliverer.id});
    try {
      const token = localStorage.getItem('access_token');
      const workStart = field === 'work_start' ? value : (deliverer.work_start || '');
      const workEnd = field === 'work_end' ? value : (deliverer.work_end || '');
      await axios.default.put(`${baseUrl}v1/admin/deliverer/${deliverer.id}/working-hours`, {
        work_start: workStart,
        work_end: workEnd,
      }, {
        headers: {Authorization: `Bearer ${token}`},
      });
      this.setState({
        users: this.state.users.map((u) => u.id === deliverer.id ? {...u, work_start: workStart, work_end: workEnd} : u),
      });
    } catch (e) {
      alert("Eroare la salvarea intervalului orar.");
    } finally {
      this.setState({savingHoursId: null});
    }
  };

  openHistory = async (event, deliverer) => {
    this.setState({historyAnchor: event.currentTarget, historyDeliverer: deliverer, historyEntries: []});
    const token = localStorage.getItem('access_token');
    const response = await axios.default.get(`${baseUrl}v1/admin/deliverer/${deliverer.id}/shift-history`, {
      headers: {Authorization: `Bearer ${token}`},
    });
    this.setState({historyEntries: response.data || []});
  };

  closeHistory = () => this.setState({historyAnchor: null, historyDeliverer: null});

  openCarHistory = async (event, deliverer) => {
    this.setState({carHistoryAnchor: event.currentTarget, carHistoryDeliverer: deliverer, carHistoryEntries: []});
    const token = localStorage.getItem('access_token');
    const response = await axios.default.get(`${baseUrl}v1/admin/deliverer/${deliverer.id}/car-history`, {
      headers: {Authorization: `Bearer ${token}`},
    });
    this.setState({carHistoryEntries: response.data || []});
  };

  closeCarHistory = () => this.setState({carHistoryAnchor: null, carHistoryDeliverer: null});

  openCreateModal = () => this.setState({modalOpen: true, editingDeliverer: null});

  openEditModal = (user) => this.setState({modalOpen: true, editingDeliverer: user});

  closeModal = () => this.setState({modalOpen: false});

  handleSaved = async () => {
    this.setState({modalOpen: false});
    await this.getDeliverers();
  };

  deleteDeliverer = async (user) => {
    if (!window.confirm(`Ștergi livratorul ${user.first_name} ${user.last_name}?`)) {
      return;
    }
    const token = localStorage.getItem('access_token');
    await axios.default.delete(`${baseUrl}v1/admin/deliverer/${user.id}`, {
      headers: {Authorization: `Bearer ${token}`},
    });
    await this.getDeliverers();
  };

  recoverDeliverer = async (user) => {
    const token = localStorage.getItem('access_token');
    await axios.default.put(`${baseUrl}v1/admin/deliverer/${user.id}/recover`, {}, {
      headers: {Authorization: `Bearer ${token}`},
    });
    await this.getDeliverers();
  };

  render() {
    const users = this.state.users || [];
    const cars = this.state.cars || [];
    const isSuperAdmin = localStorage.getItem('admin') === 'true';
    const {
      savingShiftId, savingHoursId, savingCarId, savingBonusId, modalOpen, editingDeliverer, showDeleted,
      searchTerm,
      historyAnchor, historyDeliverer, historyEntries,
      carHistoryAnchor, carHistoryDeliverer, carHistoryEntries,
    } = this.state;
    const normalizedSearch = searchTerm.trim().toLowerCase();
    const visibleUsers = (showDeleted ? users : users.filter((u) => !u.deleted))
      .filter((u) => !normalizedSearch
        || `${u.first_name} ${u.last_name}`.toLowerCase().includes(normalizedSearch));
    const activeCars = cars.filter((c) => !c.deleted);

    return (
      <div className="deliverers-page deliverers-page-scroll">
        <div className="deliverers-section">
          <div className="deliverers-section-header">
            <div className="deliverers-section-title-group">
              <h3 className="deliverers-section-title">Livratori</h3>
              <TextField
                value={searchTerm}
                onChange={(event) => this.setState({searchTerm: event.target.value})}
                placeholder="Caută după nume..."
                margin="dense"
                className="deliverers-search-input"
              />
            </div>
            <div className="deliverers-header-actions">
              <FormControlLabel
                control={
                  <Switch
                    checked={showDeleted}
                    onChange={(event) => this.setState({showDeleted: event.target.checked})}
                  />
                }
                label="Arată livratorii șterși"
              />
              <Button variant="contained" color="primary" onClick={this.openCreateModal}>
                + Adaugă livrator
              </Button>
            </div>
          </div>
          <div className="deliverers-table-scroll">
          <table className="deliverers-table">
            <thead>
            <tr>
              <th>Prenume</th>
              <th>Nume</th>
              <th>Cash</th>
              <th>Tură</th>
              <th>Start</th>
              <th>Sfârșit</th>
              <th>Mașină</th>
              <th>Oraș</th>
              <th className="deliverers-table-center">Bonus</th>
              <th>Acțiuni</th>
            </tr>
            </thead>
            <tbody>
            {visibleUsers.map((user) => (
              <tr key={user.id} className={user.deleted ? 'deliverers-row-deleted' : ''}>
                <td>{user.first_name}</td>
                <td>{user.last_name}</td>
                <td className="deliverers-table-center">{user.cash}</td>
                <td>
                  <div style={{display: 'flex', alignItems: 'center'}}>
                    <TextField
                      select
                      value={user.shift || 0}
                      onChange={(event) => this.updateShift(user, Number(event.target.value))}
                      disabled={savingShiftId === user.id || user.deleted}
                      margin="dense"
                      style={{minWidth: 130}}
                    >
                      <MenuItem value={0}>Fără tură</MenuItem>
                      <MenuItem value={1}>Tura 1</MenuItem>
                      <MenuItem value={2}>Tura 2</MenuItem>
                      <MenuItem value={3}>MieJoiVin</MenuItem>
                    </TextField>
                    <IconButton size="small" title="Istoric tură" onClick={(event) => this.openHistory(event, user)}>
                      <HistoryIcon fontSize="small"/>
                    </IconButton>
                  </div>
                </td>
                <td>
                  <TextField
                    select
                    value={user.work_start || ''}
                    onChange={(event) => this.updateWorkingHours(user, 'work_start', event.target.value)}
                    disabled={savingHoursId === user.id || user.deleted}
                    margin="dense"
                    style={{minWidth: 100}}
                  >
                    <MenuItem value="">-</MenuItem>
                    {TIME_OPTIONS.map((time) => <MenuItem key={time} value={time}>{time}</MenuItem>)}
                  </TextField>
                </td>
                <td>
                  <TextField
                    select
                    value={user.work_end || ''}
                    onChange={(event) => this.updateWorkingHours(user, 'work_end', event.target.value)}
                    disabled={savingHoursId === user.id || user.deleted}
                    margin="dense"
                    style={{minWidth: 100}}
                  >
                    <MenuItem value="">-</MenuItem>
                    {TIME_OPTIONS.map((time) => <MenuItem key={time} value={time}>{time}</MenuItem>)}
                  </TextField>
                </td>
                <td>
                  <div style={{display: 'flex', alignItems: 'center'}}>
                    <TextField
                      select
                      value={user.car_id || 0}
                      onChange={(event) => this.updateCar(user, Number(event.target.value))}
                      disabled={savingCarId === user.id || user.deleted}
                      margin="dense"
                      style={{minWidth: 160}}
                    >
                      <MenuItem value={0}>Fără mașină</MenuItem>
                      {activeCars.map((c) => (
                        <MenuItem key={c.id} value={c.id}>{c.make} {c.model} — {c.plate_number}</MenuItem>
                      ))}
                      {user.car_id && !activeCars.some((c) => c.id === user.car_id) && (
                        (() => {
                          const assignedCar = cars.find((c) => c.id === user.car_id);
                          return assignedCar
                            ? <MenuItem value={assignedCar.id}>{assignedCar.make} {assignedCar.model} — {assignedCar.plate_number} (ștearsă)</MenuItem>
                            : null;
                        })()
                      )}
                    </TextField>
                    <IconButton size="small" title="Istoric mașină" onClick={(event) => this.openCarHistory(event, user)}>
                      <HistoryIcon fontSize="small"/>
                    </IconButton>
                  </div>
                </td>
                <td>{this.cityName(user.city_id)}</td>
                <td className="deliverers-table-center">
                  <Switch
                    checked={!!user.bonus_eligible}
                    onChange={(event) => this.updateBonusEligible(user, event.target.checked)}
                    disabled={savingBonusId === user.id || user.deleted}
                  />
                </td>
                <td>
                  <div className="deliverers-row-actions">
                    <IconButton size="small" title="Inventar (premii Roata)" onClick={() => this.setState({inventoryDeliverer: user})}>
                      <CardGiftcardIcon fontSize="small"/>
                    </IconButton>
                    <IconButton size="small" title="Editează" onClick={() => this.openEditModal(user)}>
                      <EditIcon fontSize="small"/>
                    </IconButton>
                    {user.deleted ? (
                      <IconButton size="small" title="Recuperează" onClick={() => this.recoverDeliverer(user)}>
                        <RestoreFromTrashIcon fontSize="small"/>
                      </IconButton>
                    ) : (
                      <IconButton size="small" title="Șterge" onClick={() => this.deleteDeliverer(user)}>
                        <DeleteIcon fontSize="small"/>
                      </IconButton>
                    )}
                  </div>
                </td>
              </tr>
            ))}
            </tbody>
          </table>
          </div>
        </div>

        <DelivererModal
          key={`${editingDeliverer ? editingDeliverer.id : 'new'}-${modalOpen}`}
          open={modalOpen}
          deliverer={editingDeliverer}
          onClose={this.closeModal}
          onSaved={this.handleSaved}
          isSuperAdmin={isSuperAdmin}
        />

        <InventoryModal
          key={`inventory-${this.state.inventoryDeliverer ? this.state.inventoryDeliverer.id : 'none'}`}
          open={!!this.state.inventoryDeliverer}
          deliverer={this.state.inventoryDeliverer}
          onClose={() => this.setState({inventoryDeliverer: null})}
        />

        <Menu anchorEl={historyAnchor} open={!!historyAnchor} onClose={this.closeHistory}>
          {historyDeliverer && (
            <div className="deliverers-status-menu-header">
              Istoric tură — {historyDeliverer.first_name} {historyDeliverer.last_name}
            </div>
          )}
          {historyEntries.length === 0 ? (
            <MenuItem disabled>Nicio schimbare înregistrată</MenuItem>
          ) : historyEntries.map((change) => {
            const covering = change.covered_by ? users.find((u) => u.id === change.covered_by) : null;
            return (
              <MenuItem key={change.id} disabled>
                {formatDate(new Date(change.effective_from))} — {SHIFT_LABELS[change.shift] || change.shift}
                {covering && ` (acoperită de ${covering.first_name} ${covering.last_name})`}
              </MenuItem>
            );
          })}
        </Menu>

        <Menu anchorEl={carHistoryAnchor} open={!!carHistoryAnchor} onClose={this.closeCarHistory}>
          {carHistoryDeliverer && (
            <div className="deliverers-status-menu-header">
              Istoric mașină — {carHistoryDeliverer.first_name} {carHistoryDeliverer.last_name}
            </div>
          )}
          {carHistoryEntries.length === 0 ? (
            <MenuItem disabled>Nicio schimbare înregistrată</MenuItem>
          ) : carHistoryEntries.map((change) => {
            const car = change.car_id ? cars.find((c) => c.id === change.car_id) : null;
            const label = !change.car_id
              ? 'Fără mașină'
              : car
                ? `${car.make} ${car.model} — ${car.plate_number}${car.deleted ? ' (ștearsă)' : ''}`
                : 'Mașină ștearsă';
            return (
              <MenuItem key={change.id} disabled>
                {formatDate(new Date(change.effective_from))} — {label}
              </MenuItem>
            );
          })}
        </Menu>
      </div>
    )
  }
}
